// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  DefaultPage,
  AlogPage
} from './';

export default {
  path: 'alog',
  name: 'Alog',
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: AlogPage, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/alog/route.js